import type { Session } from '@supabase/supabase-js';

/** Where a signed-in student starts. */
export const STUDENT_HOME = '/practice';

/**
 * Hand a session to another app in the suite, tokens in the hash so they stay
 * client-side.
 *
 * Deliberately does not sign out first. Every signOut scope, including 'local',
 * calls GoTrue's logout endpoint, which revokes the session server-side — and
 * that is the very session whose refresh token we're handing over, so the
 * target app would receive dead credentials and bounce to its own login.
 */
export function handoffTo(appUrl: string, session: Session): void {
  const params = new URLSearchParams({
    access_token: session.access_token,
    refresh_token: session.refresh_token,
    type: 'handoff',
  });

  window.location.href = `${appUrl}/auth-handoff#${params.toString()}`;
}
